import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AboutUsResponse } from '../../types/api/aboutApi';
import { getAboutDataService } from '../../api/aboutApi';
import { AboutUsState } from '../../types/features/aboutUsSlice';



export const getAboutData = createAsyncThunk<AboutUsResponse>(
    'about/getAboutData',
    async () => {
        const response = await getAboutDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const AboutUsSlice = createSlice({
    name: 'AboutUs',
    initialState: {
        aboutUsLoader: false,
        status: false,
        msg: '',
        details: [],
        statistics: [],
        teamMembers: []
    } as AboutUsState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAboutData.pending, (state) => {
                state.aboutUsLoader = true;
            })
            .addCase(getAboutData.fulfilled, (state, action: PayloadAction<AboutUsResponse>) => {
                state.details = action.payload.data.details;
                state.statistics = action.payload.data.statistics;
                state.teamMembers = action.payload.data.teamMembers;
                state.msg = action.payload.message;
                state.status = true;
                state.aboutUsLoader = false;
            })
            .addCase(getAboutData.rejected, (state, action) => {
                state.aboutUsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
    }
});

export default AboutUsSlice.reducer;
